/* eslint-disable eqeqeq */
import axios from 'axios';
import CryptoJS from 'crypto-js';
import state from './state';
import mutations from './mutations';
import { postApi } from '../../../lib/fetcher';
import { atob, btoa } from '../../../lib/helpers';
import {api, failedReject, successReject, successApprove, failedApprove} from './constants';


const ApprovalInsertTransaction = {
  namespaced: true,
  state,
  mutations,
  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      const URL_API = api.GET_LIST_APPROVAL_INSERT_TRANSACTION;
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sortValue  = `${sortBy[0] ? sortBy[0] : 'id'} ${sort}`;

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sortBy: sortValue,
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
            page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, URL_API, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getDetail(ctx, { date, id }) {
      const URL_API = api.GET_DETAIL_REQUEST_INSERT_TRANSACTION;
      ctx.commit('setLoading', true);

      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            id + date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const responseData = await postApi(ctx, URL_API, data);

      if (responseData?.code == 200) {
        ctx.commit('setDataDetail', { payload: responseData });
        return responseData?.data;
      }

      return null;
    },
      

    async rejectInsert(ctx, { date, id, remark }) {
      const URL_API = api.SEND_REJECT_INSERT_TRANSACTION;
      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Reject');
      ctx.commit('setProgressColor', 'green');

      const data = JSON.stringify({
        id,
        remark,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;
        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);
      
      ctx.commit('setIntervalInsert', intervalId);

      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successReject(ctx, responseData);

          return true;
        } 
        clearInterval(intervalId); 
        return failedReject(ctx, responseData); 
    
      } catch (error) {
        clearInterval(intervalId); 
        return failedReject(ctx)(); 
      } finally {
        clearInterval(ctx.state.intervalRefund);
        ctx.commit('setIntervalInsert', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },
    async approveInsert(ctx, { date, id, remark }) {
      const URL_API = api.SEND_APPROVE_INSERT_TRANSACTION;

      ctx.commit('setShowProgressBar', true);
      ctx.commit('setLoading', true);
      ctx.commit('setPercentage', 0);
      ctx.commit('setProgressTitle', 'Processing Approval');
      ctx.commit('setProgressColor', 'green');

      const data = JSON.stringify({
        id,
        remark,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;
        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1); 
        }
      }, 100);
      ctx.commit('setIntervalInsert', intervalId);

      try {
        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          clearInterval(intervalId); 
          successApprove(ctx, responseData);
          return true;
        } 
        clearInterval(intervalId); 
        return failedApprove(ctx, responseData); 
      } catch (error) {
        clearInterval(intervalId);
        return failedApprove(ctx); 
      } finally {
        clearInterval(ctx.state.intervalInsert);
        ctx.commit('setIntervalInsert', null);
        setTimeout(() => {
          ctx.commit('setLoading', false);
        }, 500); 
      }
    },
    closeProgressBar({ commit }) {
      commit('setShowProgressBar', false);
    },
  },
};

export default ApprovalInsertTransaction;
